import axios, { AxiosResponse } from 'axios';

const url = '/ru/_/service/isnareactcms/gov-services';

export const getGovServices = (status?: boolean): Promise<AxiosResponse> => {
    return axios.get(url, {
        params: { status }
    });
};

export const addGovService = (data: any): Promise<AxiosResponse> => {
    return axios.post(url, data);
};

export const updateGovService = (data: any): Promise<AxiosResponse> => {
    return axios.put(url, data);
};

export const deleteGovService = (id: number): Promise<AxiosResponse> => {
    return axios.delete(url, {
        params: { id }
    });
};
